var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.078125,
    y: 0.161011,
    width: 40,
    height: 40,
    fill: "url(#pattern0_4264_47148)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4264_47148",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4264_47148",
    transform: "scale(0.0125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4264_47148",
    width: 80,
    height: 80,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAIAAAABc2X6AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAUKADAAQAAAABAAAAUAAAAAAx4ExPAAABX0lEQVR4Ae2ZwQ0CMQwEAUFViDd1UAKVUA8F0BcN3Dx88sXJenmugh3vWFoFzo/b67T1+d7fW/Lp+fts6lVi9J6XqotW9fXAVc6P6mvCo5yu6mPCVc6P6mvCo5yu6mPCVc6P6mvCo5yu6mPCVc6P6num93D0AtF3KdXPqkP1vdLkjIpuwiokaQ4TJmdU9HaE03KYNoBylc4f/bt3O8IemFZNRTdhFZI0hwmTMyp6Wg5H8zZqYFY+e6Wjzq923oRXIxa9rwlHHVvtfDvCVyIUzVXKydnqtCPsgWnFVXQTViFJc5gwOaOiYw5HB4zmLdXPqkP1vdLkjIpuwiokaQ4TJmdU9HaE03KYNoDeyXTeOUzO7NTbrbQH3rkpy3zNhJdBtfOi7Qin/T9MhkdzNZrb1Jf0doQ9MK2Cim7CKiRpDhMmZ1T0w3N4NqO80rMRyb6PCWc7Ols9E56NSPZ92hH+AyjDKD2IIrsoAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnoUser);
export default __webpack_public_path__ + "static/media/anno-user.16d4e639133df5c42f577656525f3936.svg";
export { ForwardRef as ReactComponent };